import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Router, RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NearMissService } from '../../../../services/nearMiss/nearMiss.service';
import { MatInput } from '@angular/material/input';
@Component({
    selector: 'app-download-pdf-nm',
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatInputModule,
        MatRadioModule,
        MatFormFieldModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatTableModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatMenuModule,
    ],
    templateUrl: './download-pdf-nm.component.html',
    styleUrl: './download-pdf-nm.component.css'
})
export class DownloadPdfNmComponent implements OnInit {
  @ViewChild('filterInput') filterInput: MatInput;
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['dateOfReport', 'rate', 'fileUrl']; 
  loading: boolean = true; 
  error: string | null = null; 

  constructor(private nearmissService: NearMissService, private router: Router) {}

  ngOnInit(): void {
    this.getAllPdfs();
    this.dataSource.filterPredicate = this.customFilterPredicate();
  }

  getAllPdfs(): void {
    this.nearmissService.getNearMissPdfs().subscribe(
      (res) => {
        this.dataSource.data = res;
        this.sortData('dateOfReport', 'desc');
        this.loading = false;
      },
      (error) => {
        this.error = 'Failed to load data';
        this.loading = false;
      }
    );
  }

  sortData(column: string, direction: 'asc' | 'desc'): void {
    const rateOrder = ['high', 'moderate', 'low'];

    const sortedData = [...this.dataSource.data].sort((a, b) => {
      let valueA: any;
      let valueB: any;

      switch (column) {
        case 'dateOfReport':
          valueA = new Date(a.dateOfReport).getTime();
          valueB = new Date(b.dateOfReport).getTime();
          break;
        case 'rate':
          valueA = rateOrder.indexOf(a.rate);
          valueB = rateOrder.indexOf(b.rate);
          break;
      }

      if (direction === 'asc') {
        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      } else {
        return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
      }
    });

    this.dataSource.data = sortedData;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  customFilterPredicate(): (data: any, filter: string) => boolean {
    return (data, filter) => {
      const dateObj = new Date(data.date);
      const formattedDate = dateObj.toLocaleDateString('en-US');
      const formattedDateShort = formattedDate.slice(0, 5);
      const year = dateObj.getFullYear().toString();  
      const normalizedFilter = filter.replace(/^0+/, '').toLowerCase();
      const normalizedFormattedDate = formattedDate.replace(/\/0(\d)\//g, '/$1/');
      const normalizedFormattedShort = formattedDateShort.replace(/\/0(\d)/g, '/$1');
      return (
        data.rate.toLowerCase().includes(normalizedFilter) || 
        data.completedBy.toLowerCase().includes(normalizedFilter) || 
        formattedDate.includes(filter) || 
        normalizedFormattedDate.includes(normalizedFilter) || 
        formattedDateShort.includes(filter) || 
        normalizedFormattedShort.includes(normalizedFilter) || 
        year.includes(filter)
      );
    };
  }

  clearSort(): void {
    this.getAllPdfs(); 
  }
}
